import { derived, get } from "svelte/store";

import { remoteConfig } from "./remoteConfig";

function newsLocaleToLanguage(locale: string | undefined) {
  if (!locale) {
    return "en";
  }

  const getSecondPartLocales = new Set([
    "cs-CZ",
    "da-DK",
    "el-GR",
    "en-AU",
    "en-CA",
    "en-GB",
    "en-GH",
    "en-IE",
    "en-IN",
    "en-KE",
    "en-NG",
    "en-PH",
    "en-PK",
    "en-US",
    "en-ZA",
    "he-IL",
    "hi-IN",
    "ja-JP",
    "ko-KR",
    "pt-BR",
    "ta-IN",
    "uk-UA",
    "zh-CN",
    "zh-HK",
    "zh-TW",
  ]);
  let part = 0;

  if (locale && getSecondPartLocales.has(locale)) {
    part = 1;
  }

  const lang = locale.split("-")[part];

  return ISO_639_1_LANUAGES.includes(lang) ? lang : "en";
}

export const language = derived(remoteConfig, ($remoteConfig) => {
  return newsLocaleToLanguage(
    $remoteConfig?.sysLocales?.[0] || $remoteConfig?.newsLocales[0],
  );
});

export const country = () => {
  const country =
    get(remoteConfig)?.sysLocales?.[0].split("-")[1].toLowerCase() ??
    get(remoteConfig)?.newsLocales?.[0].split("-")[1].toLowerCase();
  return ISO_3166_COUNTRIES.includes(country) ? country : "us";
};

export const getNewsLocale = (language, country) => {
  let settingsLocale =
    get(remoteConfig)?.sysLocales?.[0] ?? get(remoteConfig)?.newsLocales?.[0];

  if (settingsLocale) {
    settingsLocale = settingsLocale.replace("-", "_");

    if (NEWS_LOCALES.includes(settingsLocale)) {
      return settingsLocale;
    }
  }

  const newsLocale = `${language}_${country.toUpperCase()}`;

  return NEWS_LOCALES.includes(newsLocale) ? newsLocale : "en_zz";
};

const ISO_639_1_LANUAGES = [
  "aa",
  "ab",
  "ae",
  "af",
  "ak",
  "am",
  "an",
  "ar",
  "as",
  "av",
  "ay",
  "az",
  "ba",
  "be",
  "bg",
  "bi",
  "bm",
  "bn",
  "bo",
  "br",
  "bs",
  "ca",
  "ce",
  "ch",
  "co",
  "cr",
  "cs",
  "cu",
  "cv",
  "cy",
  "da",
  "de",
  "dv",
  "dz",
  "ee",
  "el",
  "en",
  "eo",
  "es",
  "et",
  "eu",
  "fa",
  "ff",
  "fi",
  "fj",
  "fo",
  "fr",
  "fy",
  "ga",
  "gd",
  "gl",
  "gn",
  "gu",
  "gv",
  "ha",
  "he",
  "hi",
  "ho",
  "hr",
  "ht",
  "hu",
  "hy",
  "hz",
  "ia",
  "id",
  "ie",
  "ig",
  "ii",
  "ik",
  "io",
  "is",
  "it",
  "iu",
  "ja",
  "jv",
  "ka",
  "kg",
  "ki",
  "kj",
  "kk",
  "kl",
  "km",
  "kn",
  "ko",
  "kr",
  "ks",
  "ku",
  "kv",
  "kw",
  "ky",
  "la",
  "lb",
  "lg",
  "li",
  "ln",
  "lo",
  "lt",
  "lu",
  "lv",
  "mg",
  "mh",
  "mi",
  "mk",
  "ml",
  "mn",
  "mr",
  "ms",
  "mt",
  "my",
  "na",
  "nb",
  "nd",
  "ne",
  "ng",
  "nl",
  "nn",
  "no",
  "nr",
  "nv",
  "ny",
  "oc",
  "oj",
  "om",
  "or",
  "os",
  "pa",
  "pi",
  "pl",
  "ps",
  "pt",
  "qu",
  "rm",
  "rn",
  "ro",
  "ru",
  "rw",
  "sa",
  "sc",
  "sd",
  "se",
  "sg",
  "si",
  "sk",
  "sl",
  "sm",
  "sn",
  "so",
  "sq",
  "sr",
  "ss",
  "st",
  "su",
  "sv",
  "sw",
  "ta",
  "te",
  "tg",
  "th",
  "ti",
  "tk",
  "tl",
  "tn",
  "to",
  "tr",
  "ts",
  "tt",
  "tw",
  "ty",
  "ug",
  "uk",
  "ur",
  "uz",
  "ve",
  "vi",
  "vo",
  "wa",
  "wo",
  "xh",
  "yi",
  "yo",
  "za",
  "zh",
  "zu",
];

const ISO_3166_COUNTRIES = [
  "ad",
  "ae",
  "af",
  "ag",
  "ai",
  "al",
  "am",
  "ao",
  "aq",
  "ar",
  "as",
  "at",
  "au",
  "aw",
  "ax",
  "az",
  "ba",
  "bb",
  "bd",
  "be",
  "bf",
  "bg",
  "bh",
  "bi",
  "bj",
  "bl",
  "bm",
  "bn",
  "bo",
  "bq",
  "br",
  "bs",
  "bt",
  "bv",
  "bw",
  "by",
  "bz",
  "ca",
  "cc",
  "cd",
  "cf",
  "cg",
  "ch",
  "ci",
  "ck",
  "cl",
  "cm",
  "cn",
  "co",
  "cr",
  "cu",
  "cv",
  "cw",
  "cx",
  "cy",
  "cz",
  "de",
  "dj",
  "dk",
  "dm",
  "do",
  "dz",
  "ec",
  "ee",
  "eg",
  "eh",
  "er",
  "es",
  "et",
  "fi",
  "fj",
  "fk",
  "fm",
  "fo",
  "fr",
  "ga",
  "gb",
  "gd",
  "ge",
  "gf",
  "gg",
  "gh",
  "gi",
  "gl",
  "gm",
  "gn",
  "gp",
  "gq",
  "gr",
  "gs",
  "gt",
  "gu",
  "gw",
  "gy",
  "hk",
  "hm",
  "hn",
  "hr",
  "ht",
  "hu",
  "id",
  "ie",
  "il",
  "im",
  "in",
  "io",
  "iq",
  "ir",
  "is",
  "it",
  "je",
  "jm",
  "jo",
  "jp",
  "ke",
  "kg",
  "kh",
  "ki",
  "km",
  "kn",
  "kp",
  "kr",
  "kw",
  "ky",
  "kz",
  "la",
  "lb",
  "lc",
  "li",
  "lk",
  "lr",
  "ls",
  "lt",
  "lu",
  "lv",
  "ly",
  "ma",
  "mc",
  "md",
  "me",
  "mf",
  "mg",
  "mh",
  "mk",
  "ml",
  "mm",
  "mn",
  "mo",
  "mp",
  "mq",
  "mr",
  "ms",
  "mt",
  "mu",
  "mv",
  "mw",
  "mx",
  "my",
  "mz",
  "na",
  "nc",
  "ne",
  "nf",
  "ng",
  "ni",
  "nl",
  "no",
  "np",
  "nr",
  "nu",
  "nz",
  "om",
  "pa",
  "pe",
  "pf",
  "pg",
  "ph",
  "pk",
  "pl",
  "pm",
  "pn",
  "pr",
  "ps",
  "pt",
  "pw",
  "py",
  "qa",
  "re",
  "ro",
  "rs",
  "ru",
  "rw",
  "sa",
  "sb",
  "sc",
  "sd",
  "se",
  "sg",
  "sh",
  "si",
  "sj",
  "sk",
  "sl",
  "sm",
  "sn",
  "so",
  "sr",
  "ss",
  "st",
  "sv",
  "sx",
  "sy",
  "sz",
  "tc",
  "td",
  "tf",
  "tg",
  "th",
  "tj",
  "tk",
  "tl",
  "tm",
  "tn",
  "to",
  "tr",
  "tt",
  "tv",
  "tw",
  "tz",
  "ua",
  "ug",
  "uk",
  "um",
  "us",
  "uy",
  "uz",
  "va",
  "vc",
  "ve",
  "vg",
  "vi",
  "vn",
  "vu",
  "wf",
  "ws",
  "ye",
  "yt",
  "za",
  "zm",
  "zw",
];

const NEWS_LOCALES = [
  "ar_SA",
  "bg_BG",
  "bn_BD",
  "cs_CZ",
  "da_DK",
  "de_DE",
  "el_GR",
  "en_AU",
  "en_CA",
  "en_GB",
  "en_GH",
  "en_IE",
  "en_IN",
  "en_KE",
  "en_NG",
  "en_PH",
  "en_PK",
  "en_US",
  "en_ZA",
  "es_ES",
  "es_MX",
  "fi_FI",
  "fr_CA",
  "fr_FR",
  "fr_BE",
  "gu_IN",
  "he_IL",
  "hi_IN",
  "hu_HU",
  "id_ID",
  "it_IT",
  "ja_JP",
  "ko_KR",
  "nl_BE",
  "nl_NL",
  "no_NO",
  "pl_PL",
  "pt_BR",
  "pt_PT",
  "ro_RO",
  "ru_RU",
  "ru_UA",
  "sk_SK",
  "sv_SE",
  "ta_IN",
  "th_TH",
  "tr_TR",
  "uk_UA",
  "vi_VN",
  "zh_CN",
  "zh_HK",
  "zh_TW",
];
